import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const resourceCreatedSlice = createSlice({
  name: "resourceCreated",
  initialState: false,
  reducers: {
    setResourceCreated: (_state: boolean, action: PayloadAction<boolean>) => action.payload,
  },
});

export const { setResourceCreated } = resourceCreatedSlice.actions;

export const resourceCreated = resourceCreatedSlice.reducer;

export default {
  resourceCreated,
};
